import { RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS } from './resourcePreviewConstants.js';

const CSS_THEME = {
  /**
  * Primary text color
  * Usage: Headlines
  */
  ["color-text-primary"]: {
    definitionType: "color",
    light: "#000000",
    dark: "#eeeeee"
  },
  ["color-text-primary-reverse"]: {
    definitionType: "color",
    light: "#eeeeee",
    dark: "#111111"
  },
  /**
  * Secondary text color
  * Usage: paragraphs
  */
  ["color-text-secondary"]: {
    definitionType: "color",
    light: "#251C3F",
    dark: "#dddddd"
  },
  ["color-text-dropdown-item"]: {
    definitionType: "color",
    light: "#334155",
    dark: "#dddddd"
  },
  ["color-text-darkblue"]: {
    definitionType: "color",
    light: "#475569",
    dark: "#dddddd"
  },
  /**
  * Tertiary text color
  * Usage: accompanying text, captions, ...
  */
  ["color-text-tertiary"]: {
    definitionType: "color",
    light: "#666666",
    dark: "#bbbbbb"
  },
  /**
  * Tertiary text color on light theme, but primary on dark theme
  * Usage: dimmer text on light theme, but primary on dark theme, makes it easy on the eyes
  */
  ["color-text-tertiary-on-light"]: {
    definitionType: "color",
    light: "#666666",
    dark: "#ffffff"
  },
  /**
  * quar text color
  * Usage: accompanying text, captions, ...
  */
  ["color-text-quaternary"]: {
    definitionType: "color",
    light: "#7C838A",
    dark: "#aaaaaa"
  },
  /**
  * quin text color
  * Usage: accompanying text, captions, ...
  */
  ["color-text-quinary"]: {
    definitionType: "color",
    light: "#808080",
    dark: "#999999"
  },
  /**
  * quin text color
  * Usage: accompanying text, captions, ...
  */
  ["color-text-septenary"]: {
    definitionType: "color",
    light: "#afafaf",
    dark: "#6c6c6c"
  },
  /**
  * delete text color
  * Usage: items to be deleted, ...
  */
  ["color-app-delete"]: {
    definitionType: "color",
    light: "#FF0000",
    dark: "#ff0000"
  },
  ["color-app-success"]: {
    definitionType: "color",
    light: "#24CD2B",
    dark: "#24CD2B"
  },
  ["color-text-placeholder"]: {
    definitionType: "color",
    light: "#B2B2B2",
    dark: "#666666"
  },
  /**
  * Main Fabric blue color
  */
  ["color-app-primary"]: {
    definitionType: "color",
    light: "#0011ff"
  },
  /**
  * Very light main Fabric blue color
  */
  ["color-app-primary-light"]: {
    definitionType: "color",
    light: "#ebf1ff",
    dark: "#1f1f1f"
  },
  // complementary color for the app primary
  ["color-app-primary-cmp"]: {
    definitionType: "color",
    light: "#e7e2fc"
  },
  /**
  * blue becomes unreadable on dark background
  * use this color specificaly for text or where the primary color should have better contrast
  */
  ["color-app-primary-text"]: {
    definitionType: "color",
    light: "#0011ff",
    dark: "#D1D4FF"
  },
  ["color-app-primary-text-hover"]: {
    definitionType: "color",
    light: "#2400B3",
    dark: "#bcbee5"
  },
  /**
  * on dark theme the primary color changes to white
  */
  ["color-app-primary-text-whiteOnDark"]: {
    definitionType: "color",
    light: "#0011ff",
    dark: "#FFFFFF"
  },
  /**
  * Secondary Fabric purpelish color
  */
  ["color-app-secondary"]: {
    definitionType: "color",
    light: "#4200ff",
    dark: "#EAE3FF"
  },
  /**
  * Radius used on inputs
  * Usage: Buttons, dropdown buttons, text inputs, ...
  */
  ["radius-input-sm"]: {
    definitionType: "size",
    value: "0.25rem"
  },
  ["radius-input"]: {
    definitionType: "size",
    value: "0.5rem"
  },
  ["radius-input-lg"]: {
    definitionType: "size",
    value: "0.625rem"
  },
  /**
  * Background colors
  */
  ["color-bg-contrast"]: {
    definitionType: "color",
    light: "#FFFFFF",
    dark: "#000000"
  },
  ["color-bg-contrast-reverse"]: {
    definitionType: "color",
    light: "#000000",
    dark: "#FFFFFF"
  },
  ["color-bg-primary"]: {
    definitionType: "color",
    light: "#FFFFFF",
    dark: "#222222"
  },
  ["color-bg-button-navigational-default"]: {
    definitionType: "color",
    light: "#E9E9E9",
    dark: "#2e2e2e"
  },
  ["color-bg-secondary"]: {
    definitionType: "color",
    light: "#fcfcfd",
    dark: "#262626"
  },
  ["color-bg-section"]: {
    definitionType: "color",
    light: "#f4f4f4",
    dark: "#2e2e2e"
  },
  ["color-bg-section-primary"]: {
    definitionType: "color",
    light: "#f8f8f8",
    dark: "#2a2a2a"
  },
  ["color-bg-secondary-button"]: {
    definitionType: "color",
    light: "#fafafa",
    dark: "#282828"
  },
  ["color-bg-tertiary"]: {
    definitionType: "color",
    light: "#eff1f3",
    dark: "#2b2b2b"
  },
  ["color-bg-tertiary-clean"]: {
    definitionType: "color",
    light: "#efefef",
    dark: "#2b2b2b"
  },
  ["color-bg-dropdown-item-hover"]: {
    definitionType: "color",
    light: "#F1F5F9",
    dark: "#2b2b2b"
  },
  ["color-bg-quarternary"]: {
    definitionType: "color",
    light: "#e6e6e6",
    dark: "#313131"
  },
  ["color-bg-quinary"]: {
    definitionType: "color",
    light: "#d9d9d9",
    dark: "#343434"
  },
  ["color-bg-senary"]: {
    definitionType: "color",
    light: "#c5c5c5",
    dark: "#3c3c3c"
  },
  ["color-bg-assistant"]: {
    definitionType: "color",
    light: "#ffffff",
    dark: "#2f2f2f"
  },
  ["color-bg-assistant-combobox"]: {
    definitionType: "color",
    light: "#fafafa",
    dark: "#343434"
  },
  ["color-bg-disabled"]: {
    definitionType: "color",
    light: "#c5c5c5",
    dark: "#3c3c3c"
  },
  ["color-bg-septenary"]: {
    definitionType: "color",
    light: "#b2b2b2",
    dark: "#434343"
  },
  ["color-bg-octonary"]: {
    definitionType: "color",
    light: "#929292",
    dark: "#5c5c5c"
  },
  ["color-bg-overlay"]: {
    definitionType: "color",
    light: "rgba(193, 193, 193, 0.70)",
    dark: "rgba(72, 72, 72, 0.70)"
  },
  ["color-bg-nonary"]: {
    definitionType: "color",
    light: "#2f2f2f",
    dark: "#f6f6f6"
  },
  ["color-bg-primary-reverse"]: {
    definitionType: "color",
    light: "#000000",
    dark: "#eeeeee"
  },
  ["color-bg-delete"]: {
    definitionType: "color",
    light: "#ffdfdf",
    dark: "#660000"
  },
  ["color-border-primary"]: {
    definitionType: "color",
    light: "#e3e3e4",
    dark: "#444444"
  },
  ["color-border-secondary"]: {
    definitionType: "color",
    light: "#ECECEC",
    dark: "#3a3a3a"
  },
  ["color-border-tertiary"]: {
    definitionType: "color",
    light: "#f3f3f3",
    dark: "#3a3a3a"
  },
  ["color-border-subtle"]: {
    definitionType: "color",
    light: "#eff1f3",
    dark: "#2b2b2b"
  },
  ["color-bg-note-primary"]: {
    definitionType: "color",
    light: "#fffbec",
    dark: "#333333"
  },
  ["color-text-note-primary"]: {
    definitionType: "color",
    light: "#7C838A",
    dark: "#DEDEDE"
  },
  /**
  * Box shadow spreads
  */
  ["shadow-resource-card"]: {
    definitionType: "shadow",
    value: "0 0 2px 0 rgba(0, 0, 0, .05), 0 4px 6px 0 rgba(0, 0, 0, .02);"
  },
  ["shadow-spread-default"]: {
    definitionType: "size",
    value: "0px 1px 34px 0px"
  },
  ["shadow-spread-xs"]: {
    definitionType: "size",
    value: "0px 4px 6px 0px"
  },
  ["shadow-spread-large"]: {
    definitionType: "size",
    value: "0px 1px 84px 0px"
  },
  ["shadow-spread-outline"]: {
    definitionType: "size",
    value: "0px 0px 0px 1px"
  },
  ["shadow-spread-none"]: {
    definitionType: "size",
    value: "0px 0px 0px 0px"
  },
  ["shadow-spread-within"]: {
    definitionType: "size",
    value: "0 0 10rem 0"
  },
  // base input height for buttons, text inputs
  ["height-input"]: {
    definitionType: "size",
    value: "2.5rem"
  },
  ["height-input-lg"]: {
    definitionType: "size",
    value: "3rem"
  },
  ["resource-hover-overlay-color"]: {
    definitionType: "rgba",
    value: "rgba(89, 111, 134, 0.07)"
  },
  ["height-input-xl"]: {
    definitionType: "size",
    value: "3.25rem"
  },
  ["height-input-sm"]: {
    definitionType: "size",
    value: "2.125rem"
  },
  ["color-zoom-slider-track"]: {
    definitionType: "color",
    light: "#e6e6e6",
    dark: "#444444"
  },
  ["bg-expanded-resource-extra-panel"]: {
    definitionType: "color",
    light: "#444444",
    dark: "#444444"
  },
  ["color-sidebar-resize-thumb"]: {
    definitionType: "color",
    light: "#BFBFBF",
    dark: "#999999"
  },
  ["preview-compact-card-aspect-ratio"]: {
    definitionType: "string",
    value: `${RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS.width} / ${RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS.height}`
  },
  ["color-bg-annotation"]: {
    definitionType: "color",
    light: "rgb(253, 214, 96, 0.3)",
    dark: "rgb(253, 214, 96, 0.3)"
  },
  ["color-bg-annotation-hover"]: {
    definitionType: "color",
    light: "rgb(253, 214, 96, 0.5)",
    dark: "rgb(253, 214, 96, 0.5)"
  }
};

export { CSS_THEME };
//# sourceMappingURL=theme.js.map
